export default function HeroStatCard({ label, icon: Icon, value, sub, delta }) {
  return (
    <div className="hero-card">
      <div className="hero-card__top">
        <div className="hero-card__label">
          {Icon && (
            <span className="hero-card__icon">
              <Icon />
            </span>
          )}
          {label}
        </div>
        {delta && <span className="hero-card__delta">{delta}</span>}
      </div>
      <div className="hero-card__value">{value}</div>
      {sub && <div className="hero-card__sub">{sub}</div>}
    </div>
  );
}
